/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarpCategoryCreateSubCategoryRequest } from '../models/CarpCategoryCreateSubCategoryRequest';
import type { CarpCategoryCreateSubCategoryResponseApiRespoonse } from '../models/CarpCategoryCreateSubCategoryResponseApiRespoonse';
import type { CarpCategoryDeleteSubCategoryRequest } from '../models/CarpCategoryDeleteSubCategoryRequest';
import type { CarpCategoryDeleteSubCategoryResponseApiRespoonse } from '../models/CarpCategoryDeleteSubCategoryResponseApiRespoonse';
import type { CarpCategoryListCategoryRequest } from '../models/CarpCategoryListCategoryRequest';
import type { CarpCategoryListCategoryResponseApiRespoonse } from '../models/CarpCategoryListCategoryResponseApiRespoonse';
import type { CarpCategoryListSubCategoryRequest } from '../models/CarpCategoryListSubCategoryRequest';
import type { CarpCategoryListSubCategoryResponseApiRespoonse } from '../models/CarpCategoryListSubCategoryResponseApiRespoonse';
import type { CarpCategoryShowCategoryRequest } from '../models/CarpCategoryShowCategoryRequest';
import type { CarpCategoryShowCategoryResponseApiRespoonse } from '../models/CarpCategoryShowCategoryResponseApiRespoonse';
import type { CarpCategoryShowSubCategoryRequest } from '../models/CarpCategoryShowSubCategoryRequest';
import type { CarpCategoryShowSubCategoryResponseApiRespoonse } from '../models/CarpCategoryShowSubCategoryResponseApiRespoonse';
import type { CarpCategorySyncCategoryRequest } from '../models/CarpCategorySyncCategoryRequest';
import type { CarpCategorySyncCategoryResponseApiRespoonse } from '../models/CarpCategorySyncCategoryResponseApiRespoonse';
import type { CarpCategoryUpdateSubCategoryRequest } from '../models/CarpCategoryUpdateSubCategoryRequest';
import type { CarpCategoryUpdateSubCategoryResponseApiRespoonse } from '../models/CarpCategoryUpdateSubCategoryResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CarpCategoryManagerService {

    /**
     * List CarpCategory
     * @param requestBody
     * @returns CarpCategoryListCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpCategory(
        requestBody: CarpCategoryListCategoryRequest,
    ): CancelablePromise<CarpCategoryListCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-category',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show account
     * @param requestBody
     * @returns CarpCategoryShowCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpCategoryShow(
        requestBody: CarpCategoryShowCategoryRequest,
    ): CancelablePromise<CarpCategoryShowCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-category/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Sync account
     * @param requestBody
     * @returns CarpCategorySyncCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpCategorySync(
        requestBody: CarpCategorySyncCategoryRequest,
    ): CancelablePromise<CarpCategorySyncCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-category/sync',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * List CarpCategory
     * @param requestBody
     * @returns CarpCategoryListSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpSubCategory(
        requestBody: CarpCategoryListSubCategoryRequest,
    ): CancelablePromise<CarpCategoryListSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-sub-category',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show account
     * @param requestBody
     * @returns CarpCategoryShowSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpSubCategoryShow(
        requestBody: CarpCategoryShowSubCategoryRequest,
    ): CancelablePromise<CarpCategoryShowSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-sub-category/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Create account
     * @param requestBody
     * @returns CarpCategoryCreateSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpSubCategoryCreate(
        requestBody: CarpCategoryCreateSubCategoryRequest,
    ): CancelablePromise<CarpCategoryCreateSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-sub-category/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Update account
     * @param requestBody
     * @returns CarpCategoryUpdateSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpSubCategoryUpdate(
        requestBody: CarpCategoryUpdateSubCategoryRequest,
    ): CancelablePromise<CarpCategoryUpdateSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carp-sub-category/update',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Delete account
     * @param requestBody
     * @returns CarpCategoryDeleteSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpSubCategoryDelete(
        requestBody: CarpCategoryDeleteSubCategoryRequest,
    ): CancelablePromise<CarpCategoryDeleteSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/carp-sub-category/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
